import React from 'react';

const TypingIndicator = () => {
  return (
    <div className="message-wrapper agent-message">
      <div className="message-bubble">
        <div className="typing-indicator">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
